import { administrationApiSdk } from './administrationClient.js';

/**
 * Where the administration service is, in one place.
 *
 * One backend, not four — which is the difference between this and the sibling
 * SDK's `configureBackends`. That package fronts a REST server, a chat socket,
 * two event-runtime services and a change feed, and exists to spare a second
 * surface from rediscovering all of them. Administration is one server.
 *
 * **The host still owns the environment.** Nothing here reads `import.meta.env`
 * or `process.env`, and that is deliberate rather than an oversight: config
 * comes from the environment (12-factor III) and the environment belongs to
 * whatever is deployed, which is the app and not this package. A Vite app reads
 * its `VITE_*` variables and passes the values in; a test passes literals.
 *
 * @param {Object} config
 * @param {string} [config.baseUrl]        Origin for every call. May be relative (a dev proxy's `/api`).
 * @param {Function} [config.authHeader]   async () => headers, merged into every request.
 * @param {Function} [config.onUnauthorized] Called with the error on a 401.
 */
export function configureAdministrationBackend({ baseUrl, authHeader, onUnauthorized } = {}) {
    if (baseUrl !== undefined) {
        administrationApiSdk.baseAdministrationUri = baseUrl;
    }
    if (authHeader !== undefined) {
        administrationApiSdk.customHeaderFn = authHeader;
    }
    if (onUnauthorized !== undefined) {
        administrationApiSdk.onUnauthorized = onUnauthorized;
    }
    return { baseUrl: administrationApiSdk.baseAdministrationUri };
}

export default configureAdministrationBackend;
